
import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { dashboardActions, hospitalActions, userActions } from '../../../_actions';
import CloseIcon from '@mui/icons-material/Close';
import Select from 'react-select';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  minWidth: '500px', // Adjust the value as needed
};


export default function AddTreatementModel(props) {

  let dispatch = useDispatch()
  let selector = useSelector(state=>state)
  let {physioTreatmentItems}=selector;
  let {dashboard}=selector
  let {userData}=selector&&dashboard
  let {physioTreatmentList}=selector&&dashboard&&userData || {}

  let {open,toggle} = props
  const [selectedOptions, setSelectedOptions] = useState([]);
  console.log(physioTreatmentList)
React.useEffect(()=>{
  dispatch(userActions.getPhysioTreatmentList()) 
  dispatch(dashboardActions.getPhysioProfile());
  console.log(physioTreatmentList)
  let data =physioTreatmentList&&physioTreatmentList.length>0&& physioTreatmentList?.map(item => ({ 
    value: item?.id,
    label: item?.name})) || [];
setSelectedOptions(data || []);
},[physioTreatmentItems?.length])

let options = selector?.users?.physioTreatmentItems?.map(item => ({ 
  value: item?.id,
  label: item?.name})) || [];
  
 
    let [inputData,setinputData] = React.useState()

  
    const [error, setError] = React.useState({
      title: '',
      name: '',
      mobNo: '',
      // specializationId: '',
      alternateNo: '',
      aboutUs: '',
      address: '',
      gmap: '',
    });

    let data=selectedOptions?.map((e)=>e.value)
    console.log(data)
    let submitDetails=()=>{ 
      dispatch(userActions.addTreatment({"treatmentList":data}))  
      closeModel()         
//       if(validateForm()){
// setError({
//   title: '',
//   name: '',
//   mobNo: '',
//   // specializationId: '',
//   alternateNo: '',
//   aboutUs: '',
//   address: '',
//   gmap: '',
// })
// setinputData({})



// }

 }


 let closeModel = ()=>{
  setinputData({})
  toggle();
 }


 const validateForm = () => {
  const newErrors = {};



  if (!inputData.name) {
    newErrors.name = 'Empty Field';
  }

  setError(newErrors);

  return Object.keys(newErrors).length === 0;
};


const handleChanges = (selected) => {
  setSelectedOptions(selected);
};
  return (
    <div>
      <Modal
        open={open}
       
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
      

 <div className='bg-[#005F60] rounded-md p-2  text-lg font-bold text-white flex justify-between'>
        <div >Add Treatement</div>
        <CloseIcon onClick={closeModel} className=' cursor-pointer'/>

 </div>
        <form className="max-w-md mx-auto flex flex-col  mt-8 space-y-6">
  


         <div>
    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
      Treatement 
    </label>
    <Select
      options={options}
      isMulti
      value={selectedOptions}
      onChange={handleChanges}
    />
    {/* <input
      id="name"
      name="name"
      type="text"
      placeholder="Write Treatement"
      className={`mt-1 p-2 w-full rounded-md border focus:outline-none focus:border-blue-500`}
      value={inputData?.name || ''}
      onChange={(e)=>handleChange(e)}
    /> */}
    {error['name'] && <p className='text-sm text-red-500'>{error.name}</p>}
         </div>



         <div className='flex'>



</div>







<button
  onClick={submitDetails}
  type="button"
  className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#005F60] hover:bg-[#005F40] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
>
  Submit
</button>

</form>
        </Box>
      </Modal>
    </div>
  );
}










